import Vue from 'vue'
import VueI18n from 'vue-i18n'
import checkView from 'vue-check-view'
import VueAnalytics from 'vue-analytics'
import Messages from '../../citrix-workspace/src/translations'
import MessagesOverride from './translations'
import GA_DOMAIN_MAP from '../../common/mappings/gaMap'
import vueScrollto from 'vue-scrollto'
import PricingCalculator from './PricingCalculator'
import utils from "../../common/utils";

Vue.use(vueScrollto)
Vue.use(VueI18n)
Vue.use(checkView)
Vue.config.productionTip = false

// Merge language files
const messages = utils.obj_merge(Messages, MessagesOverride)

/**
 * init i18n translation object
 * @type {VueI18n}
 */
const i18n = new VueI18n({
    fallbackLocale: 'en-us',
    locale: 'en-us', // set locale
    messages // set locale messages
})

/**
 * Load GA tracking if analytics id exists in map
 */
if(GA_DOMAIN_MAP.hasOwnProperty(document.location.hostname) && typeof ga === 'function'){
    Vue.use(VueAnalytics, {
        id: GA_DOMAIN_MAP[document.location.hostname],
        checkDuplicatedScript: true
    })
}

let elementRoot  = "pricing_calculator"

new Vue({
    i18n,
    el: `#${elementRoot}`,
    components: {
        PricingCalculator
    },
    template: "<pricing-calculator></pricing-calculator>"
})
